export const getPageNameByLocation = (loc) => {
  const { pathname } = loc;
  const pathParts = pathname.split('/');
  const pageName = pathParts[pathParts.length - 1];

  return pageName;
};
